export default __webpack_public_path__ + "locales/ko-KR/Ldap.json?hash=eaa92f78725c22636a17b8f01229ed3a";